export const NAME_REGEX = /^[a-zA-Z-' ]+$/;
export const EMAIL_REGEX = /^[^@]+@[^@]+.[^@]+$/;
export const PHONE_REGEX = /^\d+$/;
export const ONLY_STRING_REGEX = /[\s$*.()|/@#!~^&-=+;,?%0-9]/g;
export const ADDRESS_ZONE_REGEX = /^[a-zA-Z ]*$/;
